import React, { useState } from "react";

const ApkBanner = () => {
  const [showBanner, setShowBanner] = useState(true);

  const handleDownloadClick = () => {
    window.location.href = "https://play.google.com/store/apps/details?id=com.gemx.gemx";
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 backdrop-blur-xl text-white p-4 flex flex-col md:hidden z-30 banner">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-lg font-bold">Download Our App!</h2>
          <p className="text-sm">Get the best experience on your mobile device.</p>
        </div>
        <button
          onClick={() => setShowBanner(false)}
          className="text-white text-lg font-bold ml-4 -mt-7"
        >
          ✕
        </button>
      </div>
      <button
        onClick={handleDownloadClick}
        className="mt-3 bg-slate-900 text-blue-600 font-semibold py-2 px-4 rounded-lg"
      >
        Download GEMX
      </button>
    </div>
  );
};

export default ApkBanner;
